import React, { useEffect, useState } from 'react';

const LoadingTransition = ({ onLoadingComplete }) => {
  const [visibleLetters, setVisibleLetters] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  
  const fullText = "AETHERHAUS";
  const displayText = fullText.slice(0, visibleLetters);

  useEffect(() => {
    // Show letters one by one over 5 seconds
    const totalDuration = 5000; // 5 seconds
    const letterDelay = 120; // Milliseconds between each letter

    const letterTimer = setInterval(() => {
      setVisibleLetters(prev => {
        const nextCount = prev + 1;
        if (nextCount > fullText.length) {
          clearInterval(letterTimer);
          setIsComplete(true);
          // Wait a moment then trigger completion
          setTimeout(() => {
            onLoadingComplete();
          }, 800);
          return fullText.length;
        }
        return nextCount;
      });
    }, letterDelay);

    return () => clearInterval(letterTimer);
  }, [onLoadingComplete, fullText.length]);

  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-50">
      {/* Fullscreen Background Video */}
      <video 
        autoPlay 
        muted 
        loop 
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover z-0"
        style={{
          filter: visibleLetters > 0 ? 'brightness(0.4) contrast(1.2)' : 'brightness(0.6) contrast(1.1)'
        }}
        onError={() => console.log('Video failed to load')}
      >
        <source src="/architectural_light.mp4" type="video/mp4" />
      </video>
      
      {/* Fallback background if video doesn't load */}
      <div 
        className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-gray-800 z-0"
        style={{
          backgroundImage: 'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.1) 0%, transparent 50%), radial-gradient(circle at 70% 80%, rgba(255,255,255,0.05) 0%, transparent 50%)'
        }}
      />
      
      {/* Dark overlay for better text readability */}
      <div 
        className="absolute inset-0 bg-black transition-opacity duration-1000 z-10"
        style={{
          opacity: visibleLetters > 0 ? 0.3 : 0.5
        }}
      />
      
      {/* Fullscreen AETHERHAUS Text */}
      <div className="relative text-center w-full px-8 z-20">
        <h1 
          className="font-thin transition-all duration-300"
          style={{
            fontSize: '15vw', // Fits screen width properly
            color: '#ffffff',
            letterSpacing: '-0.15em', // TIGHT - letters very close
            lineHeight: '1',
            fontWeight: '100', // THIN
            transform: `${isComplete ? 'scale(0.95)' : 'scale(1)'} scaleX(0.3)`, // THIN - compress width to 30%
            transformOrigin: 'center center',
            opacity: isComplete ? 0.3 : 1,
            width: '100%',
            whiteSpace: 'nowrap'
          }}
        >
          {displayText}
        </h1>
      </div>

      {/* Fade out effect when complete */}
      <div 
        className={`absolute inset-0 bg-black transition-opacity duration-1000 z-30 ${
          isComplete ? 'opacity-100' : 'opacity-0'
        }`}
        style={{ pointerEvents: 'none' }}
      />
    </div>
  );
};

export default LoadingTransition;
